import { ThunkDispatch } from "redux-thunk";
import { IRootState } from "../store";
import {
  createBusiness,
  getBusiness,
  getUserInfo,
  getUsers,
  updateBusiness,
  updateUserInfo,
} from "../../services/user";
import {
  userBusinessAction,
  userBusinessFailureAction,
  userBusinessSuccessAction,
  createBusinessAction,
  createBusinessFailureAction,
  createBusinessSuccessAction,
  updateUserInfoAction,
  IUserActions,
  getUserInfoAction,
  getUserInfoFailureAction,
  getUserInfoSuccessAction,
  updateUserInfoSuccessAction,
  getUserListAction,
  getUserListSuccessAction,
  setListFiltersAction,
} from "../actions/user.action";
import { sessionCheck } from "./auth.thunk";
import { ICreateBusiness, IUserUpdate } from "../../interfaces/user";
import { IUserFiltersDto } from "../../interfaces/dto/user.dto";

export const getBusinessThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IUserActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.userId && auth.token) {
      dispatch(userBusinessAction());

      const business = await getBusiness(auth.userId ?? "", auth.token ?? "");

      if (business.error && dispatch(sessionCheck(business))) {
        dispatch(userBusinessFailureAction(business.error));
      } else {
        dispatch(userBusinessSuccessAction(business));
      }
    }
  };

export const createBusinessThunk =
  ({ companyName, country, type, email, name }: ICreateBusiness) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IUserActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.userId) {
      dispatch(createBusinessAction());

      const business = await createBusiness(auth.userId ?? "", {
        companyName,
        country,
        type,
        name,
        email,
      });

      if (business.error && dispatch(sessionCheck(business))) {
        dispatch(createBusinessFailureAction(business.error));
      } else {
        dispatch(createBusinessSuccessAction(business));
        dispatch(getBusinessThunk());
      }
    }
  };

export const getUserInfoThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IUserActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.userId && auth.token) {
      dispatch(getUserInfoAction());

      const user = await getUserInfo(auth.userId ?? "", auth.token ?? "");

      if (user.error && dispatch(sessionCheck(user))) {
        dispatch(getUserInfoFailureAction(user.error));
      } else {
        dispatch(getUserInfoSuccessAction(user));
      }
    }
  };

export const setUserListFiltersThunk = (filters: IUserFiltersDto) => {
  return (dispatch: ThunkDispatch<IRootState, void, IUserActions>) => {
    dispatch(setListFiltersAction(filters));
    dispatch(getUsersThunk());
  };
};

export const getUsersThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IUserActions>,
    getState: () => IRootState,
  ) => {
    const { auth, user } = getState();
    const { filters = {} } = user.list;

    if (auth.userId && auth.token) {
      dispatch(getUserListAction());

      const user = await getUsers(filters, auth.token ?? "");

      //if (user.error && dispatch(sessionCheck(user))) {
      //dispatch(getUserInfoFailureAction(user.error));
      //} else {
      dispatch(getUserListSuccessAction(user));
      //}
    }
  };

export const updateUserInfoThunk =
  (userId: string, payload: IUserUpdate) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IUserActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();
    const { name, status } = payload;

    if (auth.token) {
      dispatch(updateUserInfoAction());

      const user = await updateUserInfo(userId, { name, status }, auth.token);

      if (user.error && dispatch(sessionCheck(user))) {
        dispatch(getUserInfoFailureAction(user.error));
      } else {
        dispatch(updateUserInfoSuccessAction(user));
        dispatch(getUsersThunk());
      }
    }
  };

export const updateProfileThunk =
  (bussinessId: string, payload: ICreateBusiness & IUserUpdate) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IUserActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();
    const { companyName, country, type } = payload;

    if (auth.userId && auth.token) {
      dispatch(userBusinessAction());

      const business = await updateBusiness(
        auth.userId ?? "",
        bussinessId,
        { companyName, country, type },
        auth.token,
      );

      if (business.error && dispatch(sessionCheck(business))) {
        dispatch(userBusinessFailureAction(business.error));
      } else {
        dispatch(userBusinessSuccessAction(business));
      }

      dispatch(updateUserInfoThunk(auth.userId ?? "", payload));
    }
  };
